<template>
  <div class="modal-card"
       style="width: 80%">
    <header class="modal-card-head is-small modal-card-head-edit">
      <span class="v-icon-close"
            style="cursor: pointer;"
            @click="$emit('close')">
        <b-icon size="is-medium"
                pack="fa"
                icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="condition-search">
        <table class="table-condition table-group">
          <thead>
            <tr>
              <th>陸送会社</th>
              <th>{{this.item.isSearchAuction === 0 ? 'オークション会場' : 'ヤード'}}</th>
              <th>提携ヤード</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ item.dataFee.inlandCompanyFee[indexCompany].company_name }}</td>
              <td>{{ item.transportFromName }}</td>
              <td>{{ item.transportToName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="group-content">
        <table class="table-content table-group">
          <thead>
            <tr>
              <th>受注</th>
              <th>車台番号</th>
              <th>車種</th>
              <th>引取先</th>
              <th>出品番号</th>
              <th>納車先</th>
              <th>取扱い</th>
              <th>陸送会社</th>
              <th>顧客ID</th>
              <th>Grade</th>
              <th>費用合計</th>
              <th>陸送請求額</th>
              <th>請求合計</th>
              <th>手配完了</th>
              <th>納車予定</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for=" item in listHistory" v-if="checkList" >
              <td>{{ item.orderDate | formatDateString('YY/M/D') }}</td>
              <td>{{ item.vinNo }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.transportFromName }}</td>
              <td>{{ item.lotNo }}</td>
              <td>{{ item.transportToName }}</td>
              <td>{{ item.handlingCompanyJp }}</td>
              <td>{{ item.transportVendorName }}</td>
              <td>{{ item.customerId }}</td>
              <td>{{ item.customerGrade }}</td>
              <td>{{ item.transportTotalActualCost }}</td>
              <td>{{ item.transportCost }}</td>
              <td>{{ item.transportTotalCost }}</td>
              <td>{{ item.transportRequestConfirmDate | formatDateString('YY/M/D') }}</td>
              <td>{{ item.transportEstimatedArrivalDate | formatDateString('YY/M/D') }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!checkList"  style="width: 95%; margin: auto;">
            <p style="text-align: center;">表示するデータはありません。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import itemRepository from '@/repositories/item';
import { Item } from '@/models';
export default {
  props: [
    'item', 'indexCompany', 'store'
  ],
  data: () => ({
    listHistory: [],
    checkList: true
  }),
  async created() {
    this.init();

  },
  computed: {

  },
  methods: {
    async init() {
      this.store.commit('isLoadingApi', true);
      let filterTemp = []
      if (this.item) {
        let params = {
          transportVendorName: this.item.dataFee.inlandCompanyFee[this.indexCompany].company_name,
          transportFromName: this.item.transportFromName,
          transportToName: this.item.transportToName
        }
        filterTemp = await itemRepository.getHistoryTransports(params);
        filterTemp = filterTemp.data.map((item) => new Item(item));
        this.listHistory = filterTemp.filter(
          (item) =>
            this.filterByCompany(item) &&
            this.filterTransportToName(item) &&
            this.filterTransportFromName(item)
        );
        if(this.listHistory.length == 0){
          this.checkList = false;
        }else{
          this.checkList = true;
        }
      }
      this.store.commit('isLoadingApi', false);
    },
    filterByCompany(item) {
      if (item.transportVendorName.trim() == '' && this.item.dataFee.inlandCompanyFee[this.indexCompany].company_name.trim() == '') return true;
      return (
        item.transportVendorName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.item.dataFee.inlandCompanyFee[this.indexCompany].company_name.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterTransportToName(item) {
      if (item.transportToName.trim() == '' && this.item.transportToName.trim() == '') return true;
      return (
        item.transportToName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.item.transportToName.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
    filterTransportFromName(item) {
      if (item.transportFromName.trim() == '' && this.item.transportFromName.trim() == '') return true;
      return (
        item.transportFromName
          .trim()
          .toLowerCase()
          .replaceAll(' ', '')
          .indexOf(
            this.item.transportFromName.trim().toLowerCase().replaceAll(' ', '')
          ) >= 0
      );
    },
  },
};
</script>

<style>
.condition-search{
  width: 100%;
  margin-bottom: 20px;
}
.group-content{
  width: 100%;
}
.table-condition{
  width: 30%;
}
.table-content{
  width: 95%;
  margin: auto;
}
.table-group tr th {
  height: 30px;
  border: 1px solid #b5b5b5;
  text-align: center;
  line-height: 2.5;
  height: 30px;
}
.table-group tr td {
  text-align: center;
  border: 1px solid #b5b5b5;
  height: 30px;
  line-height: 2;
  font-size: 0.85rem;
}
.modal-card-head-edit{
  padding: 0 !important;
  justify-content: end !important;
}
.animation-content{
  width: 100%;
  margin: auto !important;
}
.modal-card{
  margin: auto !important;
}
</style>
